// Class: openfl.display._internal.Context3DGraphics

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function openfl_display_BitmapData() {return require("./../../../openfl/display/BitmapData");}
function openfl_geom_ColorTransform() {return require("./../../../openfl/geom/ColorTransform");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../../openfl/_Vector/Vector_Impl_");}
function openfl_display__$internal_DrawCommandReader() {return require("./../../../openfl/display/_internal/DrawCommandReader");}
function openfl_geom_Rectangle() {return require("./../../../openfl/geom/Rectangle");}
function openfl_geom_Matrix() {return require("./../../../openfl/geom/Matrix");}
function openfl_display__$internal__$Context3DGraphics_PolygonFunctions() {return require("./../../../openfl/display/_internal/_Context3DGraphics/PolygonFunctions");}
function openfl_display__$internal_Context3DBuffer() {return require("./../../../openfl/display/_internal/Context3DBuffer");}
function openfl_display__$internal_Context3DElementType() {return require("./../../../openfl/display/_internal/Context3DElementType");}
function lime_utils__$Float32Array_Float32Array_$Impl_$() {return require("./../../../lime/utils/_Float32Array/Float32Array_Impl_");}
function openfl_display__$internal_CanvasGraphics() {return require("./../../../openfl/display/_internal/CanvasGraphics");}
function Std() {return require("./../../../Std");}

// Constructor

var Context3DGraphics = function(){}

// Meta

Context3DGraphics.__name__ = "openfl.display._internal.Context3DGraphics";
Context3DGraphics.__isInterface__ = false;
Context3DGraphics.prototype = {
	
};
Context3DGraphics.prototype.__class__ = Context3DGraphics.prototype.constructor = $hxClasses["openfl.display._internal.Context3DGraphics"] = Context3DGraphics;

// Init



// Statics

Context3DGraphics.buildBuffer = function(graphics,renderer) {
	var quadBufferPosition = 0;
	var triangleIndexBufferPosition = 0;
	var vertexBufferPosition = 0;
	var vertexBufferPositionUVT = 0;
	var bounds = graphics.__bounds;
	var data = new (openfl_display__$internal_DrawCommandReader().default)(graphics.__commands);
	var context = renderer.__context3D;
	var tileRect = (openfl_geom_Rectangle().default).__pool.get();
	var tileTransform = (openfl_geom_Matrix().default).__pool.get();
	var bitmap = null;
	var bitmapMatrix = null;
	var scale9Grid = graphics.__owner.__scale9Grid;
	var hasScale9Grid = scale9Grid != null && !graphics.__owner.__isMask && graphics.__worldTransform.b == 0 && graphics.__worldTransform.c == 0;
	if(!hasScale9Grid) {
		scale9Grid = null;
	}
	var _g = 0;
	var _g1 = graphics.__commands.types;
	while(_g < _g1.length) {
		var type = _g1[_g];
		++_g;
		switch(type._hx_index) {
		case 0:
			var c = data.readBeginBitmapFill();
			bitmap = c.obj(0);
			bitmapMatrix = c.obj(1);
			break;
		case 1:
			bitmap = null;
			bitmapMatrix = null;
			data.skip(type);
			break;
		case 2:
			bitmap = null;
			bitmapMatrix = null;
			data.skip(type);
			break;
		case 3:
			var c1 = data.readBeginShaderFill();
			var shaderBuffer = c1.obj(0);
			bitmap = null;
			bitmapMatrix = null;
			if(shaderBuffer != null) {
				var _g2 = 0;
				var _g11 = shaderBuffer.inputCount;
				while(_g2 < _g11) {
					var i = _g2++;
					if(shaderBuffer.inputRefs[i].name == "bitmap") {
						bitmap = shaderBuffer.inputs[i];
						break;
					}
				}
			}
			break;
		case 6:
			var c2 = data.readDrawCircle();
			var x = c2.float(0);
			var y = c2.float(1);
			var radius = c2.float(2);
			var scaleX = graphics.__owner.get_scaleX();
			var scaleY = graphics.__owner.get_scaleY();
			(openfl_display__$internal__$Context3DGraphics_PolygonFunctions().default).buildEllipseVerticesAndIndices(x - radius,y - radius,radius,radius,scaleX,scaleY,Context3DGraphics.tempVerticesVector,Context3DGraphics.tempIndicesVector);
			var vertices = Context3DGraphics.tempVerticesVector;
			var indices = Context3DGraphics.tempIndicesVector;
			var uvtData = null;
			if(hasScale9Grid) {
				if(Context3DGraphics.tempScale9VerticesVector == null) {
					Context3DGraphics.tempScale9VerticesVector = (openfl__$Vector_Vector_$Impl_$().default)._new(vertices.get_length());
				} else {
					Context3DGraphics.tempScale9VerticesVector.set_length(vertices.get_length());
				}
				var i1 = 0;
				var length = vertices.get_length();
				var isX = true;
				while(i1 < length) {
					if(isX) {
						var tmp = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid1 = scale9Grid.x;
						var scale9Grid2 = scale9Grid.width;
						var bounds1 = bounds.width;
						var tmp1 = graphics.__owner.get_scaleX();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp,i1,Context3DGraphics.toScale9Position(vertices[i1],scale9Grid1,scale9Grid2,bounds1,tmp1) / graphics.__owner.get_scaleX());
					} else {
						var tmp2 = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid3 = scale9Grid.y;
						var scale9Grid4 = scale9Grid.height;
						var bounds2 = bounds.height;
						var tmp3 = graphics.__owner.get_scaleY();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp2,i1,Context3DGraphics.toScale9Position(vertices[i1],scale9Grid3,scale9Grid4,bounds2,tmp3) / graphics.__owner.get_scaleY());
					}
					++i1;
					isX = !isX;
				}
				vertices = Context3DGraphics.tempScale9VerticesVector;
			}
			if(bitmap != null && uvtData == null) {
				uvtData = Context3DGraphics.tempUvtVector;
				Context3DGraphics.populateUvtVector(vertices,bitmap,uvtData);
			}
			var hasIndices = indices != null;
			var numVertices = Math.floor(vertices.get_length() / 2);
			var length1 = hasIndices ? indices.get_length() : numVertices;
			var hasUVData = uvtData != null;
			var hasUVTData = hasUVData && uvtData.get_length() >= numVertices * 3;
			var vertLength = hasUVTData ? 4 : 2;
			var uvStride = hasUVTData ? 3 : 2;
			var dataPerVertex = vertLength + 2;
			var vertexOffset = hasUVTData ? vertexBufferPositionUVT : vertexBufferPosition;
			Context3DGraphics.resizeVertexBuffer(graphics,hasUVTData,vertexOffset + length1 * dataPerVertex);
			var vertexBufferData = hasUVTData ? graphics.__vertexBufferDataUVT : graphics.__vertexBufferData;
			var offset;
			var vertOffset;
			var uvOffset;
			var t;
			var _g3 = 0;
			var _g12 = length1;
			while(_g3 < _g12) {
				var i2 = _g3++;
				offset = vertexOffset + i2 * dataPerVertex;
				vertOffset = hasIndices ? indices[i2] * 2 : i2 * 2;
				uvOffset = hasIndices ? indices[i2] * uvStride : i2 * uvStride;
				if(hasUVTData) {
					t = uvtData[uvOffset + 2];
					vertexBufferData[offset] = vertices[vertOffset] / t;
					vertexBufferData[offset + 1] = vertices[vertOffset + 1] / t;
					vertexBufferData[offset + 2] = 0;
					vertexBufferData[offset + 3] = 1 / t;
				} else {
					vertexBufferData[offset] = vertices[vertOffset];
					vertexBufferData[offset + 1] = vertices[vertOffset + 1];
				}
				vertexBufferData[offset + vertLength] = hasUVData ? uvtData[uvOffset] : 0;
				vertexBufferData[offset + vertLength + 1] = hasUVData ? uvtData[uvOffset + 1] : 0;
			}
			if(hasUVTData) {
				vertexBufferPositionUVT += length1 * dataPerVertex;
			} else {
				vertexBufferPosition += length1 * dataPerVertex;
			}
			break;
		case 7:
			var c3 = data.readDrawEllipse();
			var x1 = c3.float(0);
			var y1 = c3.float(1);
			var radiusX = c3.float(2) / 2.0;
			var radiusY = c3.float(3) / 2.0;
			var scaleX1 = graphics.__owner.get_scaleX();
			var scaleY1 = graphics.__owner.get_scaleY();
			(openfl_display__$internal__$Context3DGraphics_PolygonFunctions().default).buildEllipseVerticesAndIndices(x1,y1,radiusX,radiusY,scaleX1,scaleY1,Context3DGraphics.tempVerticesVector,Context3DGraphics.tempIndicesVector);
			var vertices1 = Context3DGraphics.tempVerticesVector;
			var indices1 = Context3DGraphics.tempIndicesVector;
			var uvtData1 = null;
			if(hasScale9Grid) {
				if(Context3DGraphics.tempScale9VerticesVector == null) {
					Context3DGraphics.tempScale9VerticesVector = (openfl__$Vector_Vector_$Impl_$().default)._new(vertices1.get_length());
				} else {
					Context3DGraphics.tempScale9VerticesVector.set_length(vertices1.get_length());
				}
				var i3 = 0;
				var length2 = vertices1.get_length();
				var isX1 = true;
				while(i3 < length2) {
					if(isX1) {
						var tmp4 = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid5 = scale9Grid.x;
						var scale9Grid6 = scale9Grid.width;
						var bounds3 = bounds.width;
						var tmp5 = graphics.__owner.get_scaleX();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp4,i3,Context3DGraphics.toScale9Position(vertices1[i3],scale9Grid5,scale9Grid6,bounds3,tmp5) / graphics.__owner.get_scaleX());
					} else {
						var tmp6 = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid7 = scale9Grid.y;
						var scale9Grid8 = scale9Grid.height;
						var bounds4 = bounds.height;
						var tmp7 = graphics.__owner.get_scaleY();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp6,i3,Context3DGraphics.toScale9Position(vertices1[i3],scale9Grid7,scale9Grid8,bounds4,tmp7) / graphics.__owner.get_scaleY());
					}
					++i3;
					isX1 = !isX1;
				}
				vertices1 = Context3DGraphics.tempScale9VerticesVector;
			}
			if(bitmap != null && uvtData1 == null) {
				uvtData1 = Context3DGraphics.tempUvtVector;
				Context3DGraphics.populateUvtVector(vertices1,bitmap,uvtData1);
			}
			var hasIndices1 = indices1 != null;
			var numVertices1 = Math.floor(vertices1.get_length() / 2);
			var length3 = hasIndices1 ? indices1.get_length() : numVertices1;
			var hasUVData1 = uvtData1 != null;
			var hasUVTData1 = hasUVData1 && uvtData1.get_length() >= numVertices1 * 3;
			var vertLength1 = hasUVTData1 ? 4 : 2;
			var uvStride1 = hasUVTData1 ? 3 : 2;
			var dataPerVertex1 = vertLength1 + 2;
			var vertexOffset1 = hasUVTData1 ? vertexBufferPositionUVT : vertexBufferPosition;
			Context3DGraphics.resizeVertexBuffer(graphics,hasUVTData1,vertexOffset1 + length3 * dataPerVertex1);
			var vertexBufferData1 = hasUVTData1 ? graphics.__vertexBufferDataUVT : graphics.__vertexBufferData;
			var offset1;
			var vertOffset1;
			var uvOffset1;
			var t1;
			var _g4 = 0;
			var _g13 = length3;
			while(_g4 < _g13) {
				var i4 = _g4++;
				offset1 = vertexOffset1 + i4 * dataPerVertex1;
				vertOffset1 = hasIndices1 ? indices1[i4] * 2 : i4 * 2;
				uvOffset1 = hasIndices1 ? indices1[i4] * uvStride1 : i4 * uvStride1;
				if(hasUVTData1) {
					t1 = uvtData1[uvOffset1 + 2];
					vertexBufferData1[offset1] = vertices1[vertOffset1] / t1;
					vertexBufferData1[offset1 + 1] = vertices1[vertOffset1 + 1] / t1;
					vertexBufferData1[offset1 + 2] = 0;
					vertexBufferData1[offset1 + 3] = 1 / t1;
				} else {
					vertexBufferData1[offset1] = vertices1[vertOffset1];
					vertexBufferData1[offset1 + 1] = vertices1[vertOffset1 + 1];
				}
				vertexBufferData1[offset1 + vertLength1] = hasUVData1 ? uvtData1[uvOffset1] : 0;
				vertexBufferData1[offset1 + vertLength1 + 1] = hasUVData1 ? uvtData1[uvOffset1 + 1] : 0;
			}
			if(hasUVTData1) {
				vertexBufferPositionUVT += length3 * dataPerVertex1;
			} else {
				vertexBufferPosition += length3 * dataPerVertex1;
			}
			break;
		case 8:
			var c4 = data.readDrawQuads();
			var rects = c4.obj(0);
			var indices2 = c4.obj(1);
			var transforms = c4.obj(2);
			var hasIndices2 = indices2 != null;
			var transformABCD = false;
			var transformXY = false;
			var length4 = hasIndices2 ? indices2.get_length() : Math.floor(rects.get_length() / 4);
			if(length4 == 0) {
				return;
			}
			if(transforms != null) {
				if(transforms.get_length() >= length4 * 6) {
					transformABCD = true;
					transformXY = true;
				} else if(transforms.get_length() >= length4 * 4) {
					transformABCD = true;
				} else if(transforms.get_length() >= length4 * 2) {
					transformXY = true;
				}
			}
			var dataPerVertex2 = 4;
			var stride = dataPerVertex2 * 4;
			if(graphics.__quadBuffer == null) {
				graphics.__quadBuffer = new (openfl_display__$internal_Context3DBuffer().default)(context,(openfl_display__$internal_Context3DElementType().default).QUADS,length4,dataPerVertex2);
			} else {
				graphics.__quadBuffer.resize(quadBufferPosition + length4,dataPerVertex2);
			}
			var vertexOffset2;
			var tileWidth;
			var tileHeight;
			var uvX;
			var uvY;
			var uvWidth;
			var uvHeight;
			var x2;
			var y2;
			var x21;
			var y21;
			var x3;
			var y3;
			var x4;
			var y4;
			var ri;
			var ti;
			var vertexBufferData2 = graphics.__quadBuffer.vertexBufferData;
			var bitmapWidth = 1;
			var bitmapHeight = 1;
			if(bitmap != null) {
				bitmapWidth = bitmap.width;
				bitmapHeight = bitmap.height;
			}
			var _g5 = 0;
			var _g14 = length4;
			while(_g5 < _g14) {
				var i5 = _g5++;
				vertexOffset2 = (quadBufferPosition + i5) * stride;
				ri = hasIndices2 ? indices2[i5] * 4 : i5 * 4;
				if(ri < 0) {
					continue;
				}
				tileRect.setTo(rects[ri],rects[ri + 1],rects[ri + 2],rects[ri + 3]);
				tileWidth = tileRect.width;
				tileHeight = tileRect.height;
				if(tileWidth <= 0 || tileHeight <= 0) {
					continue;
				}
				if(transformABCD && transformXY) {
					ti = i5 * 6;
					tileTransform.setTo(transforms[ti],transforms[ti + 1],transforms[ti + 2],transforms[ti + 3],transforms[ti + 4],transforms[ti + 5]);
				} else if(transformABCD) {
					ti = i5 * 4;
					tileTransform.setTo(transforms[ti],transforms[ti + 1],transforms[ti + 2],transforms[ti + 3],tileRect.x,tileRect.y);
				} else if(transformXY) {
					ti = i5 * 2;
					tileTransform.tx = transforms[ti];
					tileTransform.ty = transforms[ti + 1];
				} else {
					tileTransform.tx = tileRect.x;
					tileTransform.ty = tileRect.y;
				}
				uvX = tileRect.x / bitmapWidth;
				uvY = tileRect.y / bitmapHeight;
				uvWidth = tileRect.get_right() / bitmapWidth;
				uvHeight = tileRect.get_bottom() / bitmapHeight;
				x2 = tileTransform.__transformX(0,0);
				y2 = tileTransform.__transformY(0,0);
				x21 = tileTransform.__transformX(tileWidth,0);
				y21 = tileTransform.__transformY(tileWidth,0);
				x3 = tileTransform.__transformX(0,tileHeight);
				y3 = tileTransform.__transformY(0,tileHeight);
				x4 = tileTransform.__transformX(tileWidth,tileHeight);
				y4 = tileTransform.__transformY(tileWidth,tileHeight);
				vertexBufferData2[vertexOffset2] = x2;
				vertexBufferData2[vertexOffset2 + 1] = y2;
				vertexBufferData2[vertexOffset2 + 2] = uvX;
				vertexBufferData2[vertexOffset2 + 3] = uvY;
				vertexBufferData2[vertexOffset2 + dataPerVertex2] = x21;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 + 1] = y21;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 + 2] = uvWidth;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 + 3] = uvY;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 2] = x3;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 2 + 1] = y3;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 2 + 2] = uvX;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 2 + 3] = uvHeight;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 3] = x4;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 3 + 1] = y4;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 3 + 2] = uvWidth;
				vertexBufferData2[vertexOffset2 + dataPerVertex2 * 3 + 3] = uvHeight;
			}
			quadBufferPosition += length4;
			break;
		case 9:
			if(bitmap != null) {
				var c5 = data.readDrawRect();
				Context3DGraphics.tempVerticesVector.set_length(8);
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,0,c5.float(0));
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,1,c5.float(1));
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,2,c5.float(0) + c5.float(2));
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,3,c5.float(1));
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,4,c5.float(0));
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,5,c5.float(1) + c5.float(3));
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,6,c5.float(0) + c5.float(2));
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempVerticesVector,7,c5.float(1) + c5.float(3));
				Context3DGraphics.tempIndicesVector.set_length(6);
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempIndicesVector,0,0);
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempIndicesVector,1,1);
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempIndicesVector,2,2);
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempIndicesVector,3,1);
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempIndicesVector,4,2);
				(openfl__$Vector_Vector_$Impl_$().default).set(Context3DGraphics.tempIndicesVector,5,3);
				var vertices2 = Context3DGraphics.tempVerticesVector;
				var indices3 = Context3DGraphics.tempIndicesVector;
				var uvtData2 = null;
				if(hasScale9Grid) {
					if(Context3DGraphics.tempScale9VerticesVector == null) {
						Context3DGraphics.tempScale9VerticesVector = (openfl__$Vector_Vector_$Impl_$().default)._new(vertices2.get_length());
					} else {
						Context3DGraphics.tempScale9VerticesVector.set_length(vertices2.get_length());
					}
					var i6 = 0;
					var length5 = vertices2.get_length();
					var isX2 = true;
					while(i6 < length5) {
						if(isX2) {
							var tmp8 = Context3DGraphics.tempScale9VerticesVector;
							var scale9Grid9 = scale9Grid.x;
							var scale9Grid10 = scale9Grid.width;
							var bounds5 = bounds.width;
							var tmp9 = graphics.__owner.get_scaleX();
							(openfl__$Vector_Vector_$Impl_$().default).set(tmp8,i6,Context3DGraphics.toScale9Position(vertices2[i6],scale9Grid9,scale9Grid10,bounds5,tmp9) / graphics.__owner.get_scaleX());
						} else {
							var tmp10 = Context3DGraphics.tempScale9VerticesVector;
							var scale9Grid11 = scale9Grid.y;
							var scale9Grid12 = scale9Grid.height;
							var bounds6 = bounds.height;
							var tmp11 = graphics.__owner.get_scaleY();
							(openfl__$Vector_Vector_$Impl_$().default).set(tmp10,i6,Context3DGraphics.toScale9Position(vertices2[i6],scale9Grid11,scale9Grid12,bounds6,tmp11) / graphics.__owner.get_scaleY());
						}
						++i6;
						isX2 = !isX2;
					}
					vertices2 = Context3DGraphics.tempScale9VerticesVector;
				}
				if(bitmap != null && uvtData2 == null) {
					uvtData2 = Context3DGraphics.tempUvtVector;
					Context3DGraphics.populateUvtVector(vertices2,bitmap,uvtData2);
				}
				var hasIndices3 = indices3 != null;
				var numVertices2 = Math.floor(vertices2.get_length() / 2);
				var length6 = hasIndices3 ? indices3.get_length() : numVertices2;
				var hasUVData2 = uvtData2 != null;
				var hasUVTData2 = hasUVData2 && uvtData2.get_length() >= numVertices2 * 3;
				var vertLength2 = hasUVTData2 ? 4 : 2;
				var uvStride2 = hasUVTData2 ? 3 : 2;
				var dataPerVertex3 = vertLength2 + 2;
				var vertexOffset3 = hasUVTData2 ? vertexBufferPositionUVT : vertexBufferPosition;
				Context3DGraphics.resizeVertexBuffer(graphics,hasUVTData2,vertexOffset3 + length6 * dataPerVertex3);
				var vertexBufferData3 = hasUVTData2 ? graphics.__vertexBufferDataUVT : graphics.__vertexBufferData;
				var offset2;
				var vertOffset2;
				var uvOffset2;
				var t2;
				var _g6 = 0;
				var _g15 = length6;
				while(_g6 < _g15) {
					var i7 = _g6++;
					offset2 = vertexOffset3 + i7 * dataPerVertex3;
					vertOffset2 = hasIndices3 ? indices3[i7] * 2 : i7 * 2;
					uvOffset2 = hasIndices3 ? indices3[i7] * uvStride2 : i7 * uvStride2;
					if(hasUVTData2) {
						t2 = uvtData2[uvOffset2 + 2];
						vertexBufferData3[offset2] = vertices2[vertOffset2] / t2;
						vertexBufferData3[offset2 + 1] = vertices2[vertOffset2 + 1] / t2;
						vertexBufferData3[offset2 + 2] = 0;
						vertexBufferData3[offset2 + 3] = 1 / t2;
					} else {
						vertexBufferData3[offset2] = vertices2[vertOffset2];
						vertexBufferData3[offset2 + 1] = vertices2[vertOffset2 + 1];
					}
					vertexBufferData3[offset2 + vertLength2] = hasUVData2 ? uvtData2[uvOffset2] : 0;
					vertexBufferData3[offset2 + vertLength2 + 1] = hasUVData2 ? uvtData2[uvOffset2 + 1] : 0;
				}
				if(hasUVTData2) {
					vertexBufferPositionUVT += length6 * dataPerVertex3;
				} else {
					vertexBufferPosition += length6 * dataPerVertex3;
				}
			}
			break;
		case 10:
			var c6 = data.readDrawRoundRect();
			var x5 = c6.float(0);
			var y5 = c6.float(1);
			var width = c6.float(2);
			var height = c6.float(3);
			var radiusX1 = c6.float(4) / 2.0;
			var radiusY1 = (c6.obj(0) != null ? c6.obj(0) : c6.float(4)) / 2.0;
			var scaleX2 = hasScale9Grid && c6.float(0) + radiusX1 <= scale9Grid.x && c6.float(0) + c6.float(2) - radiusX1 >= scale9Grid.x + scale9Grid.width ? 1.0 : graphics.__owner.get_scaleX();
			var scaleY2 = hasScale9Grid && c6.float(1) + radiusY1 <= scale9Grid.y && c6.float(1) + c6.float(3) - radiusX1 >= scale9Grid.y + scale9Grid.height ? 1.0 : graphics.__owner.get_scaleY();
			(openfl_display__$internal__$Context3DGraphics_PolygonFunctions().default).buildRoundRectVerticesAndIndices(x5,y5,width,height,radiusX1,radiusY1,scaleX2,scaleY2,Context3DGraphics.tempVerticesVector,Context3DGraphics.tempIndicesVector);
			var vertices3 = Context3DGraphics.tempVerticesVector;
			var indices4 = Context3DGraphics.tempIndicesVector;
			var uvtData3 = null;
			if(hasScale9Grid) {
				if(Context3DGraphics.tempScale9VerticesVector == null) {
					Context3DGraphics.tempScale9VerticesVector = (openfl__$Vector_Vector_$Impl_$().default)._new(vertices3.get_length());
				} else {
					Context3DGraphics.tempScale9VerticesVector.set_length(vertices3.get_length());
				}
				var i8 = 0;
				var length7 = vertices3.get_length();
				var isX3 = true;
				while(i8 < length7) {
					if(isX3) {
						var tmp12 = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid13 = scale9Grid.x;
						var scale9Grid14 = scale9Grid.width;
						var bounds7 = bounds.width;
						var tmp13 = graphics.__owner.get_scaleX();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp12,i8,Context3DGraphics.toScale9Position(vertices3[i8],scale9Grid13,scale9Grid14,bounds7,tmp13) / graphics.__owner.get_scaleX());
					} else {
						var tmp14 = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid15 = scale9Grid.y;
						var scale9Grid16 = scale9Grid.height;
						var bounds8 = bounds.height;
						var tmp15 = graphics.__owner.get_scaleY();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp14,i8,Context3DGraphics.toScale9Position(vertices3[i8],scale9Grid15,scale9Grid16,bounds8,tmp15) / graphics.__owner.get_scaleY());
					}
					++i8;
					isX3 = !isX3;
				}
				vertices3 = Context3DGraphics.tempScale9VerticesVector;
			}
			if(bitmap != null && uvtData3 == null) {
				uvtData3 = Context3DGraphics.tempUvtVector;
				Context3DGraphics.populateUvtVector(vertices3,bitmap,uvtData3);
			}
			var hasIndices4 = indices4 != null;
			var numVertices3 = Math.floor(vertices3.get_length() / 2);
			var length8 = hasIndices4 ? indices4.get_length() : numVertices3;
			var hasUVData3 = uvtData3 != null;
			var hasUVTData3 = hasUVData3 && uvtData3.get_length() >= numVertices3 * 3;
			var vertLength3 = hasUVTData3 ? 4 : 2;
			var uvStride3 = hasUVTData3 ? 3 : 2;
			var dataPerVertex4 = vertLength3 + 2;
			var vertexOffset4 = hasUVTData3 ? vertexBufferPositionUVT : vertexBufferPosition;
			Context3DGraphics.resizeVertexBuffer(graphics,hasUVTData3,vertexOffset4 + length8 * dataPerVertex4);
			var vertexBufferData4 = hasUVTData3 ? graphics.__vertexBufferDataUVT : graphics.__vertexBufferData;
			var offset3;
			var vertOffset3;
			var uvOffset3;
			var t3;
			var _g7 = 0;
			var _g16 = length8;
			while(_g7 < _g16) {
				var i9 = _g7++;
				offset3 = vertexOffset4 + i9 * dataPerVertex4;
				vertOffset3 = hasIndices4 ? indices4[i9] * 2 : i9 * 2;
				uvOffset3 = hasIndices4 ? indices4[i9] * uvStride3 : i9 * uvStride3;
				if(hasUVTData3) {
					t3 = uvtData3[uvOffset3 + 2];
					vertexBufferData4[offset3] = vertices3[vertOffset3] / t3;
					vertexBufferData4[offset3 + 1] = vertices3[vertOffset3 + 1] / t3;
					vertexBufferData4[offset3 + 2] = 0;
					vertexBufferData4[offset3 + 3] = 1 / t3;
				} else {
					vertexBufferData4[offset3] = vertices3[vertOffset3];
					vertexBufferData4[offset3 + 1] = vertices3[vertOffset3 + 1];
				}
				vertexBufferData4[offset3 + vertLength3] = hasUVData3 ? uvtData3[uvOffset3] : 0;
				vertexBufferData4[offset3 + vertLength3 + 1] = hasUVData3 ? uvtData3[uvOffset3 + 1] : 0;
			}
			if(hasUVTData3) {
				vertexBufferPositionUVT += length8 * dataPerVertex4;
			} else {
				vertexBufferPosition += length8 * dataPerVertex4;
			}
			break;
		case 12:
			var c7 = data.readDrawTriangles();
			var vertices4 = c7.obj(0);
			var indices5 = c7.obj(1);
			var uvtData4 = c7.obj(2);
			var culling = c7.obj(3);
			var vertices5 = vertices4;
			var uvtData5 = uvtData4;
			if(hasScale9Grid) {
				if(Context3DGraphics.tempScale9VerticesVector == null) {
					Context3DGraphics.tempScale9VerticesVector = (openfl__$Vector_Vector_$Impl_$().default)._new(vertices5.get_length());
				} else {
					Context3DGraphics.tempScale9VerticesVector.set_length(vertices5.get_length());
				}
				var i10 = 0;
				var length9 = vertices5.get_length();
				var isX4 = true;
				while(i10 < length9) {
					if(isX4) {
						var tmp16 = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid17 = scale9Grid.x;
						var scale9Grid18 = scale9Grid.width;
						var bounds9 = bounds.width;
						var tmp17 = graphics.__owner.get_scaleX();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp16,i10,Context3DGraphics.toScale9Position(vertices5[i10],scale9Grid17,scale9Grid18,bounds9,tmp17) / graphics.__owner.get_scaleX());
					} else {
						var tmp18 = Context3DGraphics.tempScale9VerticesVector;
						var scale9Grid19 = scale9Grid.y;
						var scale9Grid20 = scale9Grid.height;
						var bounds10 = bounds.height;
						var tmp19 = graphics.__owner.get_scaleY();
						(openfl__$Vector_Vector_$Impl_$().default).set(tmp18,i10,Context3DGraphics.toScale9Position(vertices5[i10],scale9Grid19,scale9Grid20,bounds10,tmp19) / graphics.__owner.get_scaleY());
					}
					++i10;
					isX4 = !isX4;
				}
				vertices5 = Context3DGraphics.tempScale9VerticesVector;
			}
			if(bitmap != null && uvtData5 == null) {
				uvtData5 = Context3DGraphics.tempUvtVector;
				Context3DGraphics.populateUvtVector(vertices5,bitmap,uvtData5);
			}
			var hasIndices5 = indices5 != null;
			var numVertices4 = Math.floor(vertices5.get_length() / 2);
			var length10 = hasIndices5 ? indices5.get_length() : numVertices4;
			var hasUVData4 = uvtData5 != null;
			var hasUVTData4 = hasUVData4 && uvtData5.get_length() >= numVertices4 * 3;
			var vertLength4 = hasUVTData4 ? 4 : 2;
			var uvStride4 = hasUVTData4 ? 3 : 2;
			var dataPerVertex5 = vertLength4 + 2;
			var vertexOffset5 = hasUVTData4 ? vertexBufferPositionUVT : vertexBufferPosition;
			Context3DGraphics.resizeVertexBuffer(graphics,hasUVTData4,vertexOffset5 + length10 * dataPerVertex5);
			var vertexBufferData5 = hasUVTData4 ? graphics.__vertexBufferDataUVT : graphics.__vertexBufferData;
			var offset4;
			var vertOffset4;
			var uvOffset4;
			var t4;
			var _g8 = 0;
			var _g17 = length10;
			while(_g8 < _g17) {
				var i11 = _g8++;
				offset4 = vertexOffset5 + i11 * dataPerVertex5;
				vertOffset4 = hasIndices5 ? indices5[i11] * 2 : i11 * 2;
				uvOffset4 = hasIndices5 ? indices5[i11] * uvStride4 : i11 * uvStride4;
				if(hasUVTData4) {
					t4 = uvtData5[uvOffset4 + 2];
					vertexBufferData5[offset4] = vertices5[vertOffset4] / t4;
					vertexBufferData5[offset4 + 1] = vertices5[vertOffset4 + 1] / t4;
					vertexBufferData5[offset4 + 2] = 0;
					vertexBufferData5[offset4 + 3] = 1 / t4;
				} else {
					vertexBufferData5[offset4] = vertices5[vertOffset4];
					vertexBufferData5[offset4 + 1] = vertices5[vertOffset4 + 1];
				}
				vertexBufferData5[offset4 + vertLength4] = hasUVData4 ? uvtData5[uvOffset4] : 0;
				vertexBufferData5[offset4 + vertLength4 + 1] = hasUVData4 ? uvtData5[uvOffset4 + 1] : 0;
			}
			if(hasUVTData4) {
				vertexBufferPositionUVT += length10 * dataPerVertex5;
			} else {
				vertexBufferPosition += length10 * dataPerVertex5;
			}
			break;
		case 13:
			bitmap = null;
			bitmapMatrix = null;
			break;
		default:
			data.skip(type);
		}
	}
	if(quadBufferPosition > 0) {
		graphics.__quadBuffer.flushVertexBufferData();
	}
	if(triangleIndexBufferPosition > 0) {
		var buffer = graphics.__triangleIndexBuffer;
		if(buffer == null || triangleIndexBufferPosition > graphics.__triangleIndexBufferCount) {
			buffer = context.createIndexBuffer(triangleIndexBufferPosition,"dynamicDraw");
			graphics.__triangleIndexBuffer = buffer;
			graphics.__triangleIndexBufferCount = triangleIndexBufferPosition;
		}
		buffer.uploadFromTypedArray(graphics.__triangleIndexBufferData);
	}
	if(vertexBufferPosition > 0) {
		var buffer1 = graphics.__vertexBuffer;
		if(buffer1 == null || vertexBufferPosition > graphics.__vertexBufferCount) {
			buffer1 = context.createVertexBuffer(vertexBufferPosition,4,"dynamicDraw");
			graphics.__vertexBuffer = buffer1;
			graphics.__vertexBufferCount = vertexBufferPosition;
		}
		buffer1.uploadFromTypedArray((lime_utils__$Float32Array_Float32Array_$Impl_$().default).toArrayBufferView(graphics.__vertexBufferData));
	}
	if(vertexBufferPositionUVT > 0) {
		var buffer2 = graphics.__vertexBufferUVT;
		if(buffer2 == null || vertexBufferPositionUVT > graphics.__vertexBufferCountUVT) {
			buffer2 = context.createVertexBuffer(vertexBufferPositionUVT,6,"dynamicDraw");
			graphics.__vertexBufferUVT = buffer2;
			graphics.__vertexBufferCountUVT = vertexBufferPositionUVT;
		}
		buffer2.uploadFromTypedArray((lime_utils__$Float32Array_Float32Array_$Impl_$().default).toArrayBufferView(graphics.__vertexBufferDataUVT));
	}
	(openfl_geom_Rectangle().default).__pool.release(tileRect);
	(openfl_geom_Matrix().default).__pool.release(tileTransform);
}
Context3DGraphics.isCompatible = function(graphics) {
	if(graphics.__owner.__worldScale9Grid != null) {
		return false;
	}
	var data = new (openfl_display__$internal_DrawCommandReader().default)(graphics.__commands);
	var hasColorFill = false;
	var hasBitmapFill = false;
	var hasShaderFill = false;
	var _g = 0;
	var _g1 = graphics.__commands.types;
	while(_g < _g1.length) {
		var type = _g1[_g];
		++_g;
		switch(type._hx_index) {
		case 0:
			var c = data.readBeginBitmapFill();
			if(c.obj(1) != null) {
				data.destroy();
				return false;
			}
			hasBitmapFill = true;
			hasColorFill = false;
			hasShaderFill = false;
			data.skip(type);
			break;
		case 1:
			hasBitmapFill = false;
			hasColorFill = true;
			hasShaderFill = false;
			data.skip(type);
			break;
		case 3:
			hasBitmapFill = false;
			hasColorFill = false;
			hasShaderFill = true;
			data.skip(type);
			break;
		case 8:
			if(hasColorFill || hasBitmapFill || hasShaderFill) {
				data.skip(type);
			} else {
				data.destroy();
				return false;
			}
			break;
		case 9:
			if(hasColorFill || hasBitmapFill || hasShaderFill) {
				data.skip(type);
			} else {
				data.destroy();
				return false;
			}
			break;
		case 12:
			if(hasColorFill || hasBitmapFill || hasShaderFill) {
				data.skip(type);
			} else {
				data.destroy();
				return false;
			}
			break;
		case 13:
			hasBitmapFill = false;
			hasColorFill = false;
			hasShaderFill = false;
			data.skip(type);
			break;
		case 18:
			data.skip(type);
			break;
		case 19:
			data.skip(type);
			break;
		default:
			data.destroy();
			return false;
		}
	}
	data.destroy();
	return true;
}
Context3DGraphics.render = function(graphics,renderer) {
	if(!graphics.__visible || graphics.__commands.get_length() == 0) {
		return;
	}
	if(graphics.__bitmap != null && !graphics.__dirty || !Context3DGraphics.isCompatible(graphics)) {
		renderer.__softwareRenderer.__pixelRatio = renderer.__pixelRatio;
		var cacheTransform = renderer.__softwareRenderer.__worldTransform;
		if(graphics.__owner.__drawableType == 7) {
			renderer.__softwareRenderer.__worldTransform = (openfl_geom_Matrix().default).__identity;
		} else {
			renderer.__softwareRenderer.__worldTransform = renderer.__worldTransform;
		}
		(openfl_display__$internal_CanvasGraphics().default).render(graphics,renderer.__softwareRenderer);
		renderer.__softwareRenderer.__worldTransform = cacheTransform;
	} else {
		graphics.__bitmap = null;
		var pixelRatio = renderer.__pixelRatio;
		graphics.__update(renderer.__worldTransform,pixelRatio);
		var bounds = graphics.__bounds;
		var width = graphics.__width;
		var height = graphics.__height;
		if(bounds != null && width >= 1 && height >= 1) {
			if(graphics.__hardwareDirty || graphics.__quadBuffer == null && graphics.__vertexBuffer == null && graphics.__vertexBufferUVT == null) {
				Context3DGraphics.buildBuffer(graphics,renderer);
			}
			var scale9Grid = graphics.__owner.__scale9Grid;
			var hasScale9Grid = scale9Grid != null && !graphics.__owner.__isMask && graphics.__worldTransform.b == 0 && graphics.__worldTransform.c == 0;
			if(!hasScale9Grid) {
				scale9Grid = null;
			}
			var data = new (openfl_display__$internal_DrawCommandReader().default)(graphics.__commands);
			var context = renderer.__context3D;
			var gl = context.gl;
			var matrix = (openfl_geom_Matrix().default).__pool.get();
			var shaderBuffer = null;
			var bitmap = null;
			var bitmapMatrix = null;
			var repeat = false;
			var smooth = false;
			var fill = null;
			var positionX = 0.0;
			var positionY = 0.0;
			var quadBufferPosition = 0;
			var shaderBufferOffset = 0;
			var triangleIndexBufferPosition = 0;
			var vertexBufferPosition = 0;
			var vertexBufferPositionUVT = 0;
			var _g = 0;
			var _g1 = graphics.__commands.types;
			while(_g < _g1.length) {
				var type = _g1[_g];
				++_g;
				switch(type._hx_index) {
				case 0:
					var c = data.readBeginBitmapFill();
					bitmap = c.obj(0);
					bitmapMatrix = c.obj(1);
					repeat = c.bool(0);
					smooth = c.bool(1);
					shaderBuffer = null;
					fill = null;
					break;
				case 1:
					var c1 = data.readBeginFill();
					var color = (Std().default).int(c1.int(0));
					var alpha = (Std().default).int(c1.float(0) * 255);
					fill = color & 16777215 | alpha << 24;
					shaderBuffer = null;
					bitmap = null;
					bitmapMatrix = null;
					break;
				case 2:
					data.skip(type);
					fill = 0;
					shaderBuffer = null;
					bitmap = null;
					bitmapMatrix = null;
					break;
				case 3:
					var c2 = data.readBeginShaderFill();
					shaderBuffer = c2.obj(0);
					shaderBufferOffset = 0;
					if(shaderBuffer == null || shaderBuffer.shader == null || shaderBuffer.shader.__bitmap == null) {
						bitmap = null;
					} else {
						bitmap = shaderBuffer.shader.__bitmap.input;
					}
					fill = null;
					bitmapMatrix = null;
					break;
				case 6:
					var c3 = data.readDrawCircle();
					var radius = c3.float(2);
					var numVertices = (openfl_display__$internal__$Context3DGraphics_PolygonFunctions().default).getEllipseNumVertices(radius,radius);
					var verticesLength = numVertices * 2;
					var indicesLength = (numVertices - 2) * 3;
					var uvDataLength = 0;
					var culling = "none";
					if(bitmap != null && uvDataLength == 0) {
						uvDataLength = verticesLength;
					}
					if(bitmap != null || uvDataLength == 0 && fill != null) {
						var numVertices1 = Math.floor(verticesLength / 2);
						var length = indicesLength > 0 ? indicesLength : numVertices1;
						var hasUVTData = uvDataLength >= numVertices1 * 3;
						var vertLength = hasUVTData ? 4 : 2;
						var uvStride = hasUVTData ? 3 : 2;
						var dataPerVertex = vertLength + 2;
						var vertexBuffer = hasUVTData ? graphics.__vertexBufferUVT : graphics.__vertexBuffer;
						var bufferPosition = hasUVTData ? vertexBufferPositionUVT : vertexBufferPosition;
						var uMatrix = renderer.__getMatrix(graphics.__owner.__renderTransform,"auto");
						var shader;
						if(shaderBuffer != null && !Context3DGraphics.maskRender) {
							shader = renderer.__initShaderBuffer(shaderBuffer);
							renderer.__setShaderBuffer(shaderBuffer);
							renderer.applyMatrix(uMatrix);
							renderer.applyBitmapData(bitmap,false,repeat);
							renderer.applyAlpha(1);
							renderer.applyColorTransform(null);
							renderer.__updateShaderBuffer(shaderBufferOffset);
						} else if(bitmap != null) {
							shader = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader);
							renderer.applyMatrix(uMatrix);
							renderer.applyBitmapData(bitmap,smooth,repeat);
							renderer.applyAlpha(graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(graphics.__owner.__worldColorTransform);
							renderer.updateShader();
						} else {
							shader = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader);
							renderer.applyMatrix(uMatrix);
							renderer.applyBitmapData(Context3DGraphics.blankBitmapData,true,repeat);
							var color1 = fill;
							Context3DGraphics.tempColorTransform.redOffset = color1 >>> 16 & 255;
							Context3DGraphics.tempColorTransform.greenOffset = color1 >>> 8 & 255;
							Context3DGraphics.tempColorTransform.blueOffset = color1 & 255;
							Context3DGraphics.tempColorTransform.__combine(graphics.__owner.__worldColorTransform);
							renderer.applyAlpha((color1 >>> 24 & 255) / 255 * graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(Context3DGraphics.tempColorTransform);
							renderer.updateShader();
						}
						if(shader.__position != null) {
							context.setVertexBufferAt(shader.__position.index,vertexBuffer,bufferPosition,hasUVTData ? "float4" : "float2");
						}
						if(shader.__textureCoord != null) {
							context.setVertexBufferAt(shader.__textureCoord.index,vertexBuffer,bufferPosition + vertLength,"float2");
						}
						switch(culling) {
						case "negative":
							context.setCulling("back");
							break;
						case "none":
							context.setCulling("none");
							break;
						case "positive":
							context.setCulling("front");
							break;
						default:
						}
						context.__drawTriangles(0,length);
						shaderBufferOffset += length;
						if(hasUVTData) {
							vertexBufferPositionUVT += dataPerVertex * length;
						} else {
							vertexBufferPosition += dataPerVertex * length;
						}
						switch(culling) {
						case "none":case "positive":
							context.setCulling("back");
							break;
						default:
						}
						renderer.__clearShader();
					}
					break;
				case 7:
					var c4 = data.readDrawEllipse();
					var radiusX = c4.float(2) / 2.0;
					var radiusY = c4.float(3) / 2.0;
					var scaleX = graphics.__owner.get_scaleX();
					var scaleY = graphics.__owner.get_scaleY();
					var numVertices2 = (openfl_display__$internal__$Context3DGraphics_PolygonFunctions().default).getEllipseNumVertices(radiusX * scaleX,radiusY * scaleY);
					var verticesLength1 = numVertices2 * 2;
					var indicesLength1 = (numVertices2 - 2) * 3;
					var uvDataLength1 = 0;
					var culling1 = "none";
					if(bitmap != null && uvDataLength1 == 0) {
						uvDataLength1 = verticesLength1;
					}
					if(bitmap != null || uvDataLength1 == 0 && fill != null) {
						var numVertices3 = Math.floor(verticesLength1 / 2);
						var length1 = indicesLength1 > 0 ? indicesLength1 : numVertices3;
						var hasUVTData1 = uvDataLength1 >= numVertices3 * 3;
						var vertLength1 = hasUVTData1 ? 4 : 2;
						var uvStride1 = hasUVTData1 ? 3 : 2;
						var dataPerVertex1 = vertLength1 + 2;
						var vertexBuffer1 = hasUVTData1 ? graphics.__vertexBufferUVT : graphics.__vertexBuffer;
						var bufferPosition1 = hasUVTData1 ? vertexBufferPositionUVT : vertexBufferPosition;
						var uMatrix1 = renderer.__getMatrix(graphics.__owner.__renderTransform,"auto");
						var shader1;
						if(shaderBuffer != null && !Context3DGraphics.maskRender) {
							shader1 = renderer.__initShaderBuffer(shaderBuffer);
							renderer.__setShaderBuffer(shaderBuffer);
							renderer.applyMatrix(uMatrix1);
							renderer.applyBitmapData(bitmap,false,repeat);
							renderer.applyAlpha(1);
							renderer.applyColorTransform(null);
							renderer.__updateShaderBuffer(shaderBufferOffset);
						} else if(bitmap != null) {
							shader1 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader1);
							renderer.applyMatrix(uMatrix1);
							renderer.applyBitmapData(bitmap,smooth,repeat);
							renderer.applyAlpha(graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(graphics.__owner.__worldColorTransform);
							renderer.updateShader();
						} else {
							shader1 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader1);
							renderer.applyMatrix(uMatrix1);
							renderer.applyBitmapData(Context3DGraphics.blankBitmapData,true,repeat);
							var color2 = fill;
							Context3DGraphics.tempColorTransform.redOffset = color2 >>> 16 & 255;
							Context3DGraphics.tempColorTransform.greenOffset = color2 >>> 8 & 255;
							Context3DGraphics.tempColorTransform.blueOffset = color2 & 255;
							Context3DGraphics.tempColorTransform.__combine(graphics.__owner.__worldColorTransform);
							renderer.applyAlpha((color2 >>> 24 & 255) / 255 * graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(Context3DGraphics.tempColorTransform);
							renderer.updateShader();
						}
						if(shader1.__position != null) {
							context.setVertexBufferAt(shader1.__position.index,vertexBuffer1,bufferPosition1,hasUVTData1 ? "float4" : "float2");
						}
						if(shader1.__textureCoord != null) {
							context.setVertexBufferAt(shader1.__textureCoord.index,vertexBuffer1,bufferPosition1 + vertLength1,"float2");
						}
						switch(culling1) {
						case "negative":
							context.setCulling("back");
							break;
						case "none":
							context.setCulling("none");
							break;
						case "positive":
							context.setCulling("front");
							break;
						default:
						}
						context.__drawTriangles(0,length1);
						shaderBufferOffset += length1;
						if(hasUVTData1) {
							vertexBufferPositionUVT += dataPerVertex1 * length1;
						} else {
							vertexBufferPosition += dataPerVertex1 * length1;
						}
						switch(culling1) {
						case "none":case "positive":
							context.setCulling("back");
							break;
						default:
						}
						renderer.__clearShader();
					}
					break;
				case 8:
					if(bitmap != null || fill != null) {
						var c5 = data.readDrawQuads();
						var rects = c5.obj(0);
						var indices = c5.obj(1);
						var transforms = c5.obj(2);
						var hasIndices = indices != null;
						var length2 = hasIndices ? indices.get_length() : Math.floor(rects.get_length() / 4);
						var uMatrix2 = renderer.__getMatrix(graphics.__owner.__renderTransform,"auto");
						var shader2;
						if(shaderBuffer != null && !Context3DGraphics.maskRender) {
							shader2 = renderer.__initShaderBuffer(shaderBuffer);
							renderer.__setShaderBuffer(shaderBuffer);
							renderer.applyMatrix(uMatrix2);
							renderer.applyBitmapData(bitmap,false,repeat);
							renderer.applyAlpha(graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(graphics.__owner.__worldColorTransform);
						} else if(bitmap != null) {
							shader2 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader2);
							renderer.applyMatrix(uMatrix2);
							renderer.applyBitmapData(bitmap,smooth,repeat);
							renderer.applyAlpha(graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(graphics.__owner.__worldColorTransform);
							renderer.updateShader();
						} else {
							shader2 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader2);
							renderer.applyMatrix(uMatrix2);
							renderer.applyBitmapData(Context3DGraphics.blankBitmapData,true,repeat);
							var color3 = fill;
							Context3DGraphics.tempColorTransform.redOffset = color3 >>> 16 & 255;
							Context3DGraphics.tempColorTransform.greenOffset = color3 >>> 8 & 255;
							Context3DGraphics.tempColorTransform.blueOffset = color3 & 255;
							Context3DGraphics.tempColorTransform.__combine(graphics.__owner.__worldColorTransform);
							renderer.applyAlpha((color3 >>> 24 & 255) / 255 * graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(Context3DGraphics.tempColorTransform);
							renderer.updateShader();
						}
						var end = quadBufferPosition + length2;
						while(quadBufferPosition < end) {
							length2 = (Std().default).int(Math.min(end - quadBufferPosition,context.__quadIndexBufferElements));
							if(length2 <= 0) {
								break;
							}
							if(shaderBuffer != null && !Context3DGraphics.maskRender) {
								renderer.__updateShaderBuffer(shaderBufferOffset);
							}
							if(shader2.__position != null) {
								context.setVertexBufferAt(shader2.__position.index,graphics.__quadBuffer.vertexBuffer,quadBufferPosition * 16,"float2");
							}
							if(shader2.__textureCoord != null) {
								context.setVertexBufferAt(shader2.__textureCoord.index,graphics.__quadBuffer.vertexBuffer,quadBufferPosition * 16 + 2,"float2");
							}
							context.drawTriangles(context.__quadIndexBuffer,0,length2 * 2);
							shaderBufferOffset += length2 * 4;
							quadBufferPosition += length2;
						}
						renderer.__clearShader();
					}
					break;
				case 9:
					var c6 = data.readDrawRect();
					if(bitmap != null) {
						var uvDataLength2 = 0;
						var culling2 = "none";
						if(bitmap != null && uvDataLength2 == 0) {
							uvDataLength2 = 8;
						}
						if(bitmap != null || uvDataLength2 == 0 && fill != null) {
							var numVertices4 = 4;
							var length3 = 6;
							var hasUVTData2 = uvDataLength2 >= numVertices4 * 3;
							var vertLength2 = hasUVTData2 ? 4 : 2;
							var uvStride2 = hasUVTData2 ? 3 : 2;
							var dataPerVertex2 = vertLength2 + 2;
							var vertexBuffer2 = hasUVTData2 ? graphics.__vertexBufferUVT : graphics.__vertexBuffer;
							var bufferPosition2 = hasUVTData2 ? vertexBufferPositionUVT : vertexBufferPosition;
							var uMatrix3 = renderer.__getMatrix(graphics.__owner.__renderTransform,"auto");
							var shader3;
							if(shaderBuffer != null && !Context3DGraphics.maskRender) {
								shader3 = renderer.__initShaderBuffer(shaderBuffer);
								renderer.__setShaderBuffer(shaderBuffer);
								renderer.applyMatrix(uMatrix3);
								renderer.applyBitmapData(bitmap,false,repeat);
								renderer.applyAlpha(1);
								renderer.applyColorTransform(null);
								renderer.__updateShaderBuffer(shaderBufferOffset);
							} else if(bitmap != null) {
								shader3 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
								renderer.setShader(shader3);
								renderer.applyMatrix(uMatrix3);
								renderer.applyBitmapData(bitmap,smooth,repeat);
								renderer.applyAlpha(graphics.__owner.__worldAlpha);
								renderer.applyColorTransform(graphics.__owner.__worldColorTransform);
								renderer.updateShader();
							} else {
								shader3 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
								renderer.setShader(shader3);
								renderer.applyMatrix(uMatrix3);
								renderer.applyBitmapData(Context3DGraphics.blankBitmapData,true,repeat);
								var color4 = fill;
								Context3DGraphics.tempColorTransform.redOffset = color4 >>> 16 & 255;
								Context3DGraphics.tempColorTransform.greenOffset = color4 >>> 8 & 255;
								Context3DGraphics.tempColorTransform.blueOffset = color4 & 255;
								Context3DGraphics.tempColorTransform.__combine(graphics.__owner.__worldColorTransform);
								renderer.applyAlpha((color4 >>> 24 & 255) / 255 * graphics.__owner.__worldAlpha);
								renderer.applyColorTransform(Context3DGraphics.tempColorTransform);
								renderer.updateShader();
							}
							if(shader3.__position != null) {
								context.setVertexBufferAt(shader3.__position.index,vertexBuffer2,bufferPosition2,hasUVTData2 ? "float4" : "float2");
							}
							if(shader3.__textureCoord != null) {
								context.setVertexBufferAt(shader3.__textureCoord.index,vertexBuffer2,bufferPosition2 + vertLength2,"float2");
							}
							switch(culling2) {
							case "negative":
								context.setCulling("back");
								break;
							case "none":
								context.setCulling("none");
								break;
							case "positive":
								context.setCulling("front");
								break;
							default:
							}
							context.__drawTriangles(0,length3);
							shaderBufferOffset += length3;
							if(hasUVTData2) {
								vertexBufferPositionUVT += dataPerVertex2 * length3;
							} else {
								vertexBufferPosition += dataPerVertex2 * length3;
							}
							switch(culling2) {
							case "none":case "positive":
								context.setCulling("back");
								break;
							default:
							}
							renderer.__clearShader();
						}
					} else if(fill != null) {
						var x = c6.float(0);
						var y = c6.float(1);
						var width1 = c6.float(2);
						var height1 = c6.float(3);
						if(hasScale9Grid) {
							var scaledLeft = Context3DGraphics.toScale9Position(c6.float(0),scale9Grid.x,scale9Grid.width,bounds.width,graphics.__owner.get_scaleX());
							var scaledTop = Context3DGraphics.toScale9Position(c6.float(1),scale9Grid.y,scale9Grid.height,bounds.height,graphics.__owner.get_scaleY());
							var scaledRight = Context3DGraphics.toScale9Position(c6.float(0) + c6.float(2),scale9Grid.x,scale9Grid.width,bounds.width,graphics.__owner.get_scaleX());
							var scaledBottom = Context3DGraphics.toScale9Position(c6.float(1) + c6.float(3),scale9Grid.y,scale9Grid.height,bounds.height,graphics.__owner.get_scaleY());
							x = scaledLeft / graphics.__owner.get_scaleX();
							y = scaledTop / graphics.__owner.get_scaleY();
							width1 = (scaledRight - scaledLeft) / graphics.__owner.get_scaleX();
							height1 = (scaledBottom - scaledTop) / graphics.__owner.get_scaleY();
						}
						matrix.identity();
						matrix.scale(width1,height1);
						matrix.tx = x;
						matrix.ty = y;
						matrix.concat(graphics.__owner.__renderTransform);
						var shader4 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
						renderer.setShader(shader4);
						renderer.applyMatrix(renderer.__getMatrix(matrix,"auto"));
						renderer.applyBitmapData(Context3DGraphics.blankBitmapData,true,repeat);
						var color5 = fill;
						Context3DGraphics.tempColorTransform.redOffset = color5 >>> 16 & 255;
						Context3DGraphics.tempColorTransform.greenOffset = color5 >>> 8 & 255;
						Context3DGraphics.tempColorTransform.blueOffset = color5 & 255;
						Context3DGraphics.tempColorTransform.__combine(graphics.__owner.__worldColorTransform);
						renderer.applyAlpha((color5 >>> 24 & 255) / 255 * graphics.__owner.__worldAlpha);
						renderer.applyColorTransform(Context3DGraphics.tempColorTransform);
						renderer.updateShader();
						var vertexBuffer3 = Context3DGraphics.blankBitmapData.getVertexBuffer(context);
						if(shader4.__position != null) {
							context.setVertexBufferAt(shader4.__position.index,vertexBuffer3,0,"float3");
						}
						if(shader4.__textureCoord != null) {
							context.setVertexBufferAt(shader4.__textureCoord.index,vertexBuffer3,3,"float2");
						}
						var indexBuffer = Context3DGraphics.blankBitmapData.getIndexBuffer(context);
						context.drawTriangles(indexBuffer);
						shaderBufferOffset += 4;
						renderer.__clearShader();
					}
					break;
				case 10:
					var c7 = data.readDrawRoundRect();
					var radiusX1 = c7.float(4) / 2.0;
					var radiusY1 = (c7.obj(0) != null ? c7.obj(0) : c7.float(4)) / 2.0;
					var scaleX1 = hasScale9Grid && c7.float(0) + radiusX1 <= scale9Grid.x && c7.float(0) + c7.float(2) - radiusX1 >= scale9Grid.x + scale9Grid.width ? 1.0 : graphics.__owner.get_scaleX();
					var scaleY1 = hasScale9Grid && c7.float(1) + radiusY1 <= scale9Grid.y && c7.float(1) + c7.float(3) - radiusX1 >= scale9Grid.y + scale9Grid.height ? 1.0 : graphics.__owner.get_scaleY();
					var numVertices5 = (openfl_display__$internal__$Context3DGraphics_PolygonFunctions().default).getRoundRectNumVertices(radiusX1 * scaleX1,radiusY1 * scaleY1);
					var verticesLength2 = numVertices5 * 2;
					var indicesLength2 = (numVertices5 - 2) * 3;
					var uvDataLength3 = 0;
					var culling3 = "none";
					if(bitmap != null && uvDataLength3 == 0) {
						uvDataLength3 = verticesLength2;
					}
					if(bitmap != null || uvDataLength3 == 0 && fill != null) {
						var numVertices6 = Math.floor(verticesLength2 / 2);
						var length4 = indicesLength2 > 0 ? indicesLength2 : numVertices6;
						var hasUVTData3 = uvDataLength3 >= numVertices6 * 3;
						var vertLength3 = hasUVTData3 ? 4 : 2;
						var uvStride3 = hasUVTData3 ? 3 : 2;
						var dataPerVertex3 = vertLength3 + 2;
						var vertexBuffer4 = hasUVTData3 ? graphics.__vertexBufferUVT : graphics.__vertexBuffer;
						var bufferPosition3 = hasUVTData3 ? vertexBufferPositionUVT : vertexBufferPosition;
						var uMatrix4 = renderer.__getMatrix(graphics.__owner.__renderTransform,"auto");
						var shader5;
						if(shaderBuffer != null && !Context3DGraphics.maskRender) {
							shader5 = renderer.__initShaderBuffer(shaderBuffer);
							renderer.__setShaderBuffer(shaderBuffer);
							renderer.applyMatrix(uMatrix4);
							renderer.applyBitmapData(bitmap,false,repeat);
							renderer.applyAlpha(1);
							renderer.applyColorTransform(null);
							renderer.__updateShaderBuffer(shaderBufferOffset);
						} else if(bitmap != null) {
							shader5 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader5);
							renderer.applyMatrix(uMatrix4);
							renderer.applyBitmapData(bitmap,smooth,repeat);
							renderer.applyAlpha(graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(graphics.__owner.__worldColorTransform);
							renderer.updateShader();
						} else {
							shader5 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader5);
							renderer.applyMatrix(uMatrix4);
							renderer.applyBitmapData(Context3DGraphics.blankBitmapData,true,repeat);
							var color6 = fill;
							Context3DGraphics.tempColorTransform.redOffset = color6 >>> 16 & 255;
							Context3DGraphics.tempColorTransform.greenOffset = color6 >>> 8 & 255;
							Context3DGraphics.tempColorTransform.blueOffset = color6 & 255;
							Context3DGraphics.tempColorTransform.__combine(graphics.__owner.__worldColorTransform);
							renderer.applyAlpha((color6 >>> 24 & 255) / 255 * graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(Context3DGraphics.tempColorTransform);
							renderer.updateShader();
						}
						if(shader5.__position != null) {
							context.setVertexBufferAt(shader5.__position.index,vertexBuffer4,bufferPosition3,hasUVTData3 ? "float4" : "float2");
						}
						if(shader5.__textureCoord != null) {
							context.setVertexBufferAt(shader5.__textureCoord.index,vertexBuffer4,bufferPosition3 + vertLength3,"float2");
						}
						switch(culling3) {
						case "negative":
							context.setCulling("back");
							break;
						case "none":
							context.setCulling("none");
							break;
						case "positive":
							context.setCulling("front");
							break;
						default:
						}
						context.__drawTriangles(0,length4);
						shaderBufferOffset += length4;
						if(hasUVTData3) {
							vertexBufferPositionUVT += dataPerVertex3 * length4;
						} else {
							vertexBufferPosition += dataPerVertex3 * length4;
						}
						switch(culling3) {
						case "none":case "positive":
							context.setCulling("back");
							break;
						default:
						}
						renderer.__clearShader();
					}
					break;
				case 12:
					var c8 = data.readDrawTriangles();
					var vertices = c8.obj(0);
					var indices1 = c8.obj(1);
					var uvtData = c8.obj(2);
					var culling4 = c8.obj(3);
					var verticesLength3 = vertices.get_length();
					var indicesLength3 = indices1 != null ? indices1.get_length() : 0;
					var uvDataLength4 = uvtData != null ? uvtData.get_length() : 0;
					if(bitmap != null && uvDataLength4 == 0) {
						uvDataLength4 = verticesLength3;
					}
					if(bitmap != null || uvDataLength4 == 0 && fill != null) {
						var numVertices7 = Math.floor(verticesLength3 / 2);
						var length5 = indicesLength3 > 0 ? indicesLength3 : numVertices7;
						var hasUVTData4 = uvDataLength4 >= numVertices7 * 3;
						var vertLength4 = hasUVTData4 ? 4 : 2;
						var uvStride4 = hasUVTData4 ? 3 : 2;
						var dataPerVertex4 = vertLength4 + 2;
						var vertexBuffer5 = hasUVTData4 ? graphics.__vertexBufferUVT : graphics.__vertexBuffer;
						var bufferPosition4 = hasUVTData4 ? vertexBufferPositionUVT : vertexBufferPosition;
						var uMatrix5 = renderer.__getMatrix(graphics.__owner.__renderTransform,"auto");
						var shader6;
						if(shaderBuffer != null && !Context3DGraphics.maskRender) {
							shader6 = renderer.__initShaderBuffer(shaderBuffer);
							renderer.__setShaderBuffer(shaderBuffer);
							renderer.applyMatrix(uMatrix5);
							renderer.applyBitmapData(bitmap,false,repeat);
							renderer.applyAlpha(1);
							renderer.applyColorTransform(null);
							renderer.__updateShaderBuffer(shaderBufferOffset);
						} else if(bitmap != null) {
							shader6 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader6);
							renderer.applyMatrix(uMatrix5);
							renderer.applyBitmapData(bitmap,smooth,repeat);
							renderer.applyAlpha(graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(graphics.__owner.__worldColorTransform);
							renderer.updateShader();
						} else {
							shader6 = Context3DGraphics.maskRender ? renderer.__maskShader : renderer.__initGraphicsShader(null);
							renderer.setShader(shader6);
							renderer.applyMatrix(uMatrix5);
							renderer.applyBitmapData(Context3DGraphics.blankBitmapData,true,repeat);
							var color7 = fill;
							Context3DGraphics.tempColorTransform.redOffset = color7 >>> 16 & 255;
							Context3DGraphics.tempColorTransform.greenOffset = color7 >>> 8 & 255;
							Context3DGraphics.tempColorTransform.blueOffset = color7 & 255;
							Context3DGraphics.tempColorTransform.__combine(graphics.__owner.__worldColorTransform);
							renderer.applyAlpha((color7 >>> 24 & 255) / 255 * graphics.__owner.__worldAlpha);
							renderer.applyColorTransform(Context3DGraphics.tempColorTransform);
							renderer.updateShader();
						}
						if(shader6.__position != null) {
							context.setVertexBufferAt(shader6.__position.index,vertexBuffer5,bufferPosition4,hasUVTData4 ? "float4" : "float2");
						}
						if(shader6.__textureCoord != null) {
							context.setVertexBufferAt(shader6.__textureCoord.index,vertexBuffer5,bufferPosition4 + vertLength4,"float2");
						}
						switch(culling4) {
						case "negative":
							context.setCulling("back");
							break;
						case "none":
							context.setCulling("none");
							break;
						case "positive":
							context.setCulling("front");
							break;
						default:
						}
						context.__drawTriangles(0,length5);
						shaderBufferOffset += length5;
						if(hasUVTData4) {
							vertexBufferPositionUVT += dataPerVertex4 * length5;
						} else {
							vertexBufferPosition += dataPerVertex4 * length5;
						}
						switch(culling4) {
						case "none":case "positive":
							context.setCulling("back");
							break;
						default:
						}
						renderer.__clearShader();
					}
					break;
				case 13:
					bitmap = null;
					bitmapMatrix = null;
					fill = null;
					shaderBuffer = null;
					data.skip(type);
					context.setCulling("none");
					break;
				case 18:
					var c9 = data.readMoveTo();
					positionX = c9.float(0);
					positionY = c9.float(1);
					break;
				case 19:
					var c10 = data.readOverrideBlendMode();
					renderer.__setBlendMode(c10.obj(0));
					break;
				default:
					data.skip(type);
				}
			}
			(openfl_geom_Matrix().default).__pool.release(matrix);
		}
		graphics.set___dirty(false);
	}
	graphics.__hardwareDirty = false;
}
Context3DGraphics.renderMask = function(graphics,renderer) {
	Context3DGraphics.maskRender = true;
	Context3DGraphics.render(graphics,renderer);
	Context3DGraphics.maskRender = false;
}
Context3DGraphics.resizeIndexBuffer = function(graphics,isQuad,length) {
	if(isQuad) {
		return;
	}
	var buffer = isQuad ? null : graphics.__triangleIndexBufferData;
	var position = 0;
	var newBuffer = null;
	if(buffer == null) {
		var array = null;
		var vector = null;
		var view = null;
		var buffer1 = null;
		var len = null;
		var this1;
		if(length != null) {
			this1 = new Uint16Array(length);
		} else if(array != null) {
			this1 = new Uint16Array(array);
		} else if(vector != null) {
			this1 = new Uint16Array(vector);
		} else if(view != null) {
			this1 = new Uint16Array(view);
		} else if(buffer1 != null) {
			if(len == null) {
				this1 = new Uint16Array(buffer1,0);
			} else {
				this1 = new Uint16Array(buffer1,0,len);
			}
		} else {
			this1 = null;
		}
		newBuffer = this1;
	} else if(length > buffer.length) {
		var array1 = null;
		var vector1 = null;
		var view1 = null;
		var buffer2 = null;
		var len1 = null;
		var this2;
		if(length != null) {
			this2 = new Uint16Array(length);
		} else if(array1 != null) {
			this2 = new Uint16Array(array1);
		} else if(vector1 != null) {
			this2 = new Uint16Array(vector1);
		} else if(view1 != null) {
			this2 = new Uint16Array(view1);
		} else if(buffer2 != null) {
			if(len1 == null) {
				this2 = new Uint16Array(buffer2,0);
			} else {
				this2 = new Uint16Array(buffer2,0,len1);
			}
		} else {
			this2 = null;
		}
		newBuffer = this2;
		newBuffer.set(buffer);
		position = buffer.length;
	}
	if(newBuffer != null) {
		if(!isQuad) {
			graphics.__triangleIndexBufferData = newBuffer;
		}
	}
}
Context3DGraphics.resizeVertexBuffer = function(graphics,hasUVTData,length) {
	var buffer = hasUVTData ? graphics.__vertexBufferDataUVT : graphics.__vertexBufferData;
	var newBuffer = null;
	if(buffer == null) {
		var array = null;
		var vector = null;
		var view = null;
		var buffer1 = null;
		var len = null;
		var this1;
		if(length != null) {
			this1 = new Float32Array(length);
		} else if(array != null) {
			this1 = new Float32Array(array);
		} else if(vector != null) {
			this1 = new Float32Array(vector);
		} else if(view != null) {
			this1 = new Float32Array(view);
		} else if(buffer1 != null) {
			if(len == null) {
				this1 = new Float32Array(buffer1,0);
			} else {
				this1 = new Float32Array(buffer1,0,len);
			}
		} else {
			this1 = null;
		}
		newBuffer = this1;
	} else if(length > buffer.length) {
		var array1 = null;
		var vector1 = null;
		var view1 = null;
		var buffer2 = null;
		var len1 = null;
		var this2;
		if(length != null) {
			this2 = new Float32Array(length);
		} else if(array1 != null) {
			this2 = new Float32Array(array1);
		} else if(vector1 != null) {
			this2 = new Float32Array(vector1);
		} else if(view1 != null) {
			this2 = new Float32Array(view1);
		} else if(buffer2 != null) {
			if(len1 == null) {
				this2 = new Float32Array(buffer2,0);
			} else {
				this2 = new Float32Array(buffer2,0,len1);
			}
		} else {
			this2 = null;
		}
		newBuffer = this2;
		newBuffer.set(buffer);
	}
	if(newBuffer != null) {
		if(hasUVTData) {
			graphics.__vertexBufferDataUVT = newBuffer;
		} else {
			graphics.__vertexBufferData = newBuffer;
		}
	}
}
Context3DGraphics.populateUvtVector = function(vertices,bitmap,result) {
	var minX = vertices[0];
	var maxX = minX;
	var minY = vertices[1];
	var maxY = minY;
	var i = 2;
	var length = vertices.get_length();
	while(i < length) {
		var x = vertices[i];
		if(minX > x) {
			minX = x;
		} else if(maxX < x) {
			maxX = x;
		}
		var y = vertices[i + 1];
		if(minY > y) {
			minY = y;
		} else if(maxY < y) {
			maxY = y;
		}
		i += 2;
	}
	var trianglesWidth = maxX - minX;
	var trianglesHeight = maxY - minY;
	result.set_length(length);
	i = 0;
	while(i < length) {
		(openfl__$Vector_Vector_$Impl_$().default).set(result,i,trianglesWidth * (vertices[i] / trianglesWidth) / bitmap.width);
		(openfl__$Vector_Vector_$Impl_$().default).set(result,i + 1,trianglesHeight * (vertices[i + 1] / trianglesHeight) / bitmap.height);
		i += 2;
	}
}
Context3DGraphics.toScale9Position = function(pos,scale9Start,scale9Center,unscaledSize,scale) {
	if(scale <= 0.0) {
		return 0.0;
	}
	var scale9End = unscaledSize - scale9Center - scale9Start;
	var size = unscaledSize * scale;
	var center = size - scale9Start - scale9End;
	if(pos <= scale9Start) {
		if(center < 0.0) {
			return pos * (scale9Start + scale9End + center) / (scale9Start + scale9End);
		}
		return pos;
	}
	if(pos >= scale9Start + scale9Center) {
		if(center < 0.0) {
			return (scale9Start + (pos - scale9Start - scale9Center)) * (scale9Start + scale9End + center) / (scale9Start + scale9End);
		}
		return scale9Start + center + (pos - scale9Start - scale9Center);
	}
	if(center < 0.0) {
		return scale9Start * (scale9Start + scale9End + center) / (scale9Start + scale9End);
	}
	return scale9Start + center * (pos - scale9Start) / scale9Center;
}
Context3DGraphics.__meta__ = { obj : { SuppressWarnings : ["checkstyle:FieldDocComment"]}}
Context3DGraphics.blankBitmapData = new (openfl_display_BitmapData().default)(1,1,false,0)
Context3DGraphics.tempColorTransform = new (openfl_geom_ColorTransform().default)(1,1,1,1,0,0,0,0)
Context3DGraphics.tempVerticesVector = (openfl__$Vector_Vector_$Impl_$().default)._new()
Context3DGraphics.tempIndicesVector = (openfl__$Vector_Vector_$Impl_$().default)._new()
Context3DGraphics.tempUvtVector = (openfl__$Vector_Vector_$Impl_$().default)._new()

// Export

exports.default = Context3DGraphics;